<!-- eslint-disable camelcase -->
<template>
  <div>
    <Stack>
      <Buttons
        v-for="questionnaire in questionnaires"
        :key="questionnaire.name"
      >
        <Button
          :href="questionnaire.url"
          variant="primary"
          icon-after="fas fa-external-link-alt"
          target="_blank"
        >
          {{ questionnaire.name }}
        </Button>
      </Buttons>
    </Stack>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';
import { Button, Buttons, Stack } from '@stakeui';

const clientPortalStore = useClientPortalStore();

const props = defineProps({
  entityExternalId: {
    type: String,
    default: '',
  },
  firmSlug: {
    type: String,
    required: false,
    default: '',
  },
  advisorSlug: {
    type: String,
    required: false,
    default: '',
  },
});

const questionnaires = computed(() => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const items = [
    {
      name: 'Risk Questionnaire',
      url: `${baseUrl}/questionnaire/questions/v2_${btoa(props.entityExternalId)}/?questionnaire_type=risk`,
    },
    {
      name: 'Behavioral Values Questionnaire',
      url: `${baseUrl}/questionnaire/questions/v2_${btoa(props.entityExternalId)}/`,
    },
  ];

  if (clientPortalStore.portalContext?.advisor?.link_slug) {
    items.push({
      name: 'Values Picker',
      url: `${baseUrl}/ui/visitor/wizard?advisor=${clientPortalStore.portalContext.advisor.link_slug}&prospect=${props.entityExternalId}`,
    });
  }

  return items;
});

</script>
